// Redirects the browser to the payment provider.
// myPOS requires an auto-submitted POST form; Stripe uses a GET redirect URL.
export function submitPayment(data) {
  if (!data) return false;
  if (data.mode === "mypos" && data.checkout_url && data.fields) {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = data.checkout_url;
    Object.entries(data.fields).forEach(([k, v]) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = k;
      input.value = String(v);
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
    return true;
  }
  if (data.mode === "stripe" && data.checkout_url) {
    window.location.href = data.checkout_url;
    return true;
  }
  return false;
}
